import { Box, Flex, IconButton, Image } from '@chakra-ui/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import Cookies from 'universal-cookie';

import { brandLogoMap } from 'Asset/image/brand';
import { ChevronDownIcon, ChevronUpIcon, MicrophoneIcon, PencilOutlineIcon, StoreIcon, TrashOutlineIcon, UserIcon } from 'Asset/icon';
import { Condition, Iteration } from 'Component/others';
import BadgeEcomerce from 'Component/badge-ecommerce';
import { TextBold, TextSemiBold } from 'UiKit/typography';
import BadgeArea from 'Component/badge-area';

import BadgeNoActiveHost from 'View/schedule/component/badge-no-active-host';
import useModalDeleteSchedule from 'View/schedule/helper/useModalDeleteSchedule';
import { useScheduleState } from 'View/schedule/state';

import styles from './styles.module.css';

const BrandScheduleAccordion = ({ data }) => {
  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;
  const { t } = useTranslation('schedule');
  const [isOpen, setIsOpen] = useState(data?.isOpen || false);
  const { updateState } = useScheduleState();

  const { onOpenModalDeleteSchedule } = useModalDeleteSchedule();

  const handleEditEvent = (item) => {
    const selectedSchedule = {
      eventName: item.title,
      id: item?.id,
      type: 'Live',
      hosts: item?.rawData?.hosts?.filter((host) => host.isActive),
      accounts: item?.rawData?.accountLivestreams?.map((account) => ({
        ...account,
        brandName: item?.brandName,
      })),
      operators: item?.rawData?.operators,
      studio: item?.rawData?.studio,
      selectedDate: item?.rawData?.startedAt,
      startedAt: moment.tz(item?.rawData?.startedAt, timezone).toISOString(),
      endedAt: moment.tz(item?.rawData?.endedAt, timezone).toISOString(),
    };

    updateState({
      isOpenFormUpsert: true,
      isEditFormUpsert: true,
      isDialogOpen: true,
      initialSelectedSchedule: selectedSchedule,
    });
  };

  const handleDeleteEvent = (id) => {
    updateState({ isDialogOpen: true });
    onOpenModalDeleteSchedule({ id, onClose: () => updateState({ isDialogOpen: false }) });
  };

  return (
    <Box className={styles['accordion__container']}>
      <Box className={styles['accordion__section--panel']} onClick={() => setIsOpen(!isOpen)}>
        <Image src={brandLogoMap[data?.brandName]} height={'30px'} width={'auto'} />
        <Condition statement={!isOpen} fallback={<ChevronUpIcon size="18px" className={styles['accordion__icon--chevron-panel']} />}>
          <ChevronDownIcon size="18px" className={styles['accordion__icon--chevron-panel']} />
        </Condition>
      </Box>
      <Condition statement={isOpen}>
        <Box className={styles['accordion__section--items']}>
          <Iteration
            items={data?.details}
            render={(item) => {
              return (
                <Box
                  className={`${styles['accordion__box--item']} ${!item.hosts && styles['accordion__box--item-disabled']}`}
                  borderLeft={`8px solid ${item?.studio?.area?.color || '#FFEA8480'}`}
                >
                  <Box className={styles['accordion__box--item-head']}>
                    <TextBold>{item?.title}</TextBold>
                    <Flex gap={'12px'}>
                      <IconButton
                        icon={<PencilOutlineIcon size="18px" />}
                        onClick={() => handleEditEvent(item)}
                        aria-label={t('ariaEditEvent')}
                        variant="ghost"
                        className={styles['action-button']}
                      />
                      <IconButton
                        icon={<TrashOutlineIcon size="18px" />}
                        onClick={() => handleDeleteEvent(item?.id)}
                        aria-label={t('ariaDeleteEvent')}
                        variant="ghost"
                        className={styles['action-button']}
                      />
                    </Flex>
                  </Box>
                  <Box className={styles['accordion__box--item-content']}>
                    <Box className={styles['accordion__box--item-content-left']}>
                      <Box className={styles['accordion__box--store']}>
                        <StoreIcon size="18px" color="var(--color-neutral50)" />
                        <Box className={styles['accordion__box--store-list']}>
                          <Iteration
                            items={item?.accountLivestreams}
                            render={(account) => {
                              return <BadgeEcomerce ecommerce={account?.ecommerce} accountName={account?.name} />;
                            }}
                          />
                        </Box>
                      </Box>
                      <Box className={styles['accordion__box--location']}>
                        <BadgeArea studioData={item?.studio} />
                      </Box>
                    </Box>
                    <Box className={styles['accordion__box--item-content-right']}>
                      <Box className={styles['accordion__box--host']}>
                        <MicrophoneIcon size="18px" color="var(--color-neutral50)" />
                        <Condition statement={item?.hosts} fallback={<BadgeNoActiveHost />}>
                          <TextSemiBold className={styles['accordion__text--host-name']}>{item?.hosts}</TextSemiBold>
                        </Condition>
                      </Box>
                      <Box className={styles['accordion__box--operator']}>
                        <UserIcon size="18px" color="var(--color-neutral50)" />
                        <TextSemiBold className={styles['accordion__text--operator-name']}>{item?.operators}</TextSemiBold>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              );
            }}
          />
        </Box>
      </Condition>
    </Box>
  );
};

export default BrandScheduleAccordion;
